import bus from '@/utils/EventBus';
import awsInfo from '@/utils/websocket';
import { nanoid } from 'nanoid';
import { createStore } from 'vuex';

import notification from './ notification';
import auth from './auth';
import events from './events';
import googleAuth from './googleAuth';

const store = createStore({
  state: {
    user: {
      name: null,
      organisation: null,
      userType: null,
    },
    devices: [],
    addCameraData: null,
  },
  getters: {
    deviceId: (state) => (id) => (state.devices || []).find((d) => d.id === id),
  },
  mutations: {
    setUserInfo(state, { name, organisation, userType }) {
      state.user = { name, organisation, userType };
    },
    changeAddCameraData(state, payload) {
      state.addCameraData = payload;
    },
    setDevices(state, devices) {
      state.devices = devices;
    },
    setCameraDetails(state, payload) {
      if (
        !payload ||
        !payload.cameraId ||
        !payload.cameraName ||
        !payload.deviceName
      ) {
        console.warn('Missing details!', payload);
      }
      sendCameraDetails(
        payload.cameraId,
        payload.cameraName,
        payload.deviceName
      );
    },
  },
  actions: {
    setAddCamera({ commit }, payload) {
      commit('changeAddCameraData', payload);
    },
  },
  modules: {
    auth,
    events,
    notification,
    googleAuth,
  },
});

const messageHandlers = {
  GetMyInfo(message) {
    store.commit('setUserInfo', {
      name: message?.data?.user?.name,
      organisation: message?.data?.org?.name,
      userType: message?.data?.user?.type,
    });
  },
  liveview(message) {
    // Handled by Janus
    console.debug('liveview', message);
  },
  AddCamera(message) {
    if (message.status === 200) {
      awsInfo.list();

      if (message.data.result === 'added') {
        const { cameraId } = message.data;
        const { deviceId, name: cameraName } = store.state.addCameraData;

        const device = store.getters.deviceId(deviceId);
        const isAddedCamera =
          device.cameras.some((camera) => camera.id === cameraId) &&
          device.cameras.length === 1;
        const deviceName =
          device.cameras.length === 0 || isAddedCamera ? device.name : '';

        sendCameraDetails(cameraId, cameraName, deviceName);
      }
    }
  },
  GetDeviceList(message) {
    if (message.status !== 200) return;
    console.log('Recieved devices:', message.data.devices);
    store.commit('setDevices', message.data.devices);
  },
};

bus.$on('receivedMessageEvent', (message) => {
  if (typeof messageHandlers[message.response] === 'function') {
    messageHandlers[message.response](message);
  } else {
    // eslint-disable-next-line no-console
    console.warn('No handler for message type', message.response, message);
  }
});

export default store;

function sendCameraDetails(cameraId, cameraName, deviceName) {
  const transactionId = nanoid();

  const liveviewMessage = {
    action: 'liveview',
    data: {
      camId: cameraId,
      transactionId,
      webRtcData: {
        config: 'setDeviceDetails',
        cameras: [
          {
            suid: cameraId,
            name: cameraName,
          },
        ],
      },
    },
  };

  console.log('Setting device details:', liveviewMessage);

  if (deviceName !== null && deviceName !== undefined && deviceName !== '') {
    liveviewMessage.data.webRtcData.name = deviceName;
    console.log('Set liveview device name', deviceName);
  }

  console.log('Full liveview set:', liveviewMessage);

  awsInfo.aws.send_object(liveviewMessage.action, liveviewMessage.data);
}
